import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function AdminAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
    fetchAppointments();
  }, [filterStatus]);

  const fetchAppointments = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/appointments`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let data = response.data;
      if (filterStatus !== 'all') {
        data = data.filter((apt) => apt.status === filterStatus);
      }
      setAppointments(data);
    } catch (error) {
      console.error('Error fetching appointments:', error);
      navigate('/login');
    } finally {
      setLoading(false);
    }
  };

  const updateAppointmentStatus = async (id, status) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${import.meta.env.VITE_API_URL}/appointments/${id}`,
        { status },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      fetchAppointments();
    } catch (error) {
      console.error('Error updating appointment:', error);
    }
  };

  if (loading) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="row mb-4">
        <div className="col-md-8">
          <h2>Manage Appointments</h2>
        </div>
        <div className="col-md-4">
          <select
            className="form-control"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Patient</th>
              <th>Doctor</th>
              <th>Department</th>
              <th>Appointment Date</th>
              <th>Booking Mode</th>
              <th>Fee</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {appointments.map((apt) => (
              <tr key={apt.id}>
                <td>{apt.user?.name}</td>
                <td>{apt.doctor?.name}</td>
                <td>{apt.department?.name}</td>
                <td>{new Date(apt.appointment_date).toLocaleDateString()}</td>
                <td>
                  <span className="badge bg-info">{apt.booking_mode}</span>
                </td>
                <td>₹{apt.total_fee}</td>
                <td>
                  <span
                    className={`badge bg-${
                      apt.status === 'completed'
                        ? 'success'
                        : apt.status === 'pending'
                        ? 'warning'
                        : apt.status === 'confirmed'
                        ? 'info'
                        : 'danger'
                    }`}
                  >
                    {apt.status}
                  </span>
                </td>
                <td>
                  <div className="btn-group btn-group-sm" role="group">
                    {apt.status === 'pending' && (
                      <button
                        className="btn btn-success"
                        onClick={() =>
                          updateAppointmentStatus(apt.id, 'confirmed')
                        }
                      >
                        Confirm
                      </button>
                    )}
                    {apt.status !== 'completed' && apt.status !== 'cancelled' && (
                      <>
                        <button
                          className="btn btn-info"
                          onClick={() =>
                            updateAppointmentStatus(apt.id, 'completed')
                          }
                        >
                          Complete
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() =>
                            updateAppointmentStatus(apt.id, 'cancelled')
                          }
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {appointments.length === 0 && (
        <div className="alert alert-info">No appointments found.</div>
      )}
    </div>
  );
}
